import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import {
  BsArrowDownLeft,
  BsArrowDownRight,
  BsArrowUpRight,
  BsCheckCircleFill,
  BsClockFill,
  BsXCircleFill,
} from "react-icons/bs";
import { DashboardBigChart, DashboardSmallChart } from "../components/Charts";
import {
  appointmentsData,
  dashboardCards,
  memberData,
  transactionData,
} from "../components/Datas";
import { PatientTable } from "../components/Tables";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../Util/Loading";
import staffApi from "../api/user/staff.api";
import toast from "react-hot-toast";
import userApi from "../api/user/user.api";
import moment from "moment";
import TodayAppointments from "./Dashboad/TodayAppintment";
import TopServices from "./Dashboad/TopServices";
import UpcomingAppointments from "./Dashboad/UpcomingApointment";
import TopTeamMember from "./Dashboad/TopTeamMember";
import MonthlyAppointmentsChart from "./Dashboad/MonthlyApoinmentChart";
import TopServicesChart from "./Dashboad/TopServiceChart";
import CustomersCard from "./Dashboad/CustomerCard";
import CustomerGrowthChart from "./Dashboad/CustomerGrowthChart";
import orderingApi from "../api/ordering/OrderApi";
import OrdersStatsCard from "./Dashboad/OrderStaticstic";

function Dashboard() {
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [isLoading, setIsLoading] = useState(false);
  const [staffs, setStaffs] = useState([]);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [customers, setCustomers] = useState([]);
  const [orders, setOrders] = useState([]);

  const getAllOrders = async () => {
    try {
      const { response } = await orderingApi.getAllOrders();

      if (response && response.data) {
        setOrders(response.data.orders); // ⚠️ important
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching orders:", error);
    }
  };

  const getAllCustomers = async () => {
    try {
      const { response, err } = await userApi.getAllUsers();

      if (response && response.data) {
        setCustomers(response.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getAllOrders(), getAllCustomers()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Layout>
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6 items-stretch mb-20">

        <div className="bg-dry p-0 h-full">
          <MonthlyAppointmentsChart orders={orders} />
        </div>
        <div className="bg-dry p-0 h-full">
          <UpcomingAppointments orders={orders} />
        </div>
        {/* 🔹 Row 2 */}
        <div className="bg-dry p-0 h-full">
          <TodayAppointments orders={orders} />
        </div>
        <div className="bg-dry p-0 h-full">
          <OrdersStatsCard orders={orders} />
        </div>
        <div className="bg-dry p-0 h-full">
          <TopServicesChart orders={orders} />
        </div>
        {/* 🔹 Row 3: Side-by-side */}
        <div className="bg-dry p-0 h-full">
          <CustomersCard customers={customers} orders={orders} />
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;
